import React from "react";

export const SeasonLiturgy = ({size = 20, ...props}) => {
	return (
		<svg
			height={size}
			viewBox="0 0 64 64"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g data-name="Color copy">
				<g fill="#aae1f9">
					<path d="M32 52a1 1 0 01-.788-1.614 14.148 14.148 0 0118.217-3.668l3.306 1.86a6.152 6.152 0 004.95.473 1 1 0 01.632 1.9 8.152 8.152 0 01-6.562-.628l-3.307-1.86a12.161 12.161 0 00-15.658 3.153A1 1 0 0132 52z" />
					<path d="M32 52a1 1 0 01-.79-.386 12.162 12.162 0 00-15.658-3.153l-3.307 1.86a8.147 8.147 0 01-6.562.628 1 1 0 01.632-1.9 6.14 6.14 0 004.95-.473l3.306-1.86a14.149 14.149 0 0118.217 3.668A1 1 0 0132 52z" />
					<path d="M32 52a1 1 0 01-.833-.445l-.558-.837A14.219 14.219 0 0012.447 45.9a3.242 3.242 0 01-4.342-1.447 1 1 0 011.79-.9 1.235 1.235 0 001.658.553 16.222 16.222 0 0120.721 5.5l.558.837A1 1 0 0132 52z" />
					<path d="M32 52a1 1 0 01-.831-1.555l.558-.837a16.225 16.225 0 0120.721-5.5 1.237 1.237 0 001.658-.553 1 1 0 011.79.9 3.241 3.241 0 01-4.343 1.445 14.22 14.22 0 00-18.163 4.818l-.558.837A1 1 0 0132 52z" />
				</g>
				<path
					d="M40 38a1 1 0 01-.707-1.707l5-5a1 1 0 011.414 1.414l-5 5A1 1 0 0140 38zM23 38a1 1 0 01-.759-.349l-6-7a1 1 0 011.518-1.3l6 7A1 1 0 0123 38zM24 32a1 1 0 01-.9-.553l-1-2a1 1 0 011.79-.894l1 2A1 1 0 0124 32zM40 32a1 1 0 01-.894-1.447l1-2a1 1 0 011.79.894l-1 2A1 1 0 0140 32z"
					fill="#f9e109"
				/>
				<path
					d="M58 57l-26-4a5.518 5.518 0 016.807-5.366l13.235 3.176A7.975 7.975 0 0158 57z"
					fill="#57b7eb"
				/>
				<path
					d="M6 57l26-4a5.518 5.518 0 00-6.807-5.366L11.958 50.81A7.975 7.975 0 006 57z"
					fill="#57b7eb"
				/>
				<path
					d="M51.042 52.81l-13.235-3.176a5.507 5.507 0 00-5.619 1.949A5.537 5.537 0 0032 53l24.155 3.716a7.972 7.972 0 00-5.113-3.906zM26.193 49.634L12.958 52.81a7.972 7.972 0 00-5.113 3.906L32 53a5.537 5.537 0 00-.188-1.417 5.507 5.507 0 00-5.619-1.949z"
					fill="#4891d3"
				/>
				<g>
					<path d="M32 17v20h4V21h8v-4z" fill="#fcbc04" />
					<path d="M44 17v-4h-8V7h-4v10z" fill="#f9e109" />
					<path d="M32 7h-4v6h-8v4h12z" fill="#fcbc04" />
					<path d="M20 17v4h8v16h4V17z" fill="#e59730" />
				</g>
				<path
					d="M3 57v4l23.043-3.414A3.451 3.451 0 0130 61h4a3.451 3.451 0 013.957-3.414L61 61v-4l-29-5z"
					fill="#f9e109"
				/>
				<g fill="#f9e109">
					<path d="M32 11l-4-4h8zM32 33l-4 4h8zM40 17l4 4v-8zM24 17l-4 4v-8z" />
				</g>
				<path
					d="M3 59v2l23.043-3.414A3.451 3.451 0 0130 61h4a3.451 3.451 0 013.957-3.414L61 61v-2l-29-5z"
					fill="#fcbc04"
				/>
			</g>
		</svg>
	);
}

export default SeasonLiturgy;
